import { render, staticRenderFns } from "./TaskDetailReasonMenu.vue?vue&type=template&id=4d27c698"
import script from "./TaskDetailReasonMenu.vue?vue&type=script&lang=js"
export * from "./TaskDetailReasonMenu.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailReasonMenu.vue?vue&type=style&index=0&id=4d27c698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports